module.exports = __webpack_public_path__ + "static/img/bb957d45.png";